import React, {useMemo} from 'react'
import {FormattedNumber, FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {IStation} from '../../../../models/Station'
import {PHOTO_RATIO} from '../../../config/constants'
import { getGlobalEnv } from '../../../helpers/coreUtil'
import {getStationUrl, localizeStation} from '../../../helpers/station'
import LocaleText from '../../common/LocaleText'
import ResponsiveImg, { getResponsiveSrcSetsFromWH } from '../../common/ResponsiveImg'
import TopStarThumbnail from '../../common/TopStarThumbnail'
import {useLocale} from '../../hocs/hooks'
import styles from './StationItem.scss'

const thumbnailWidth = 320 //px
const StationItem = ({station}: {station: IStation}) => {
  const locale = useLocale()
  const {
    activityOnly,
    activityPrice,
    price,
    stars,
    totalReviews,
    name,
    photos: [{url, caption} = {}],
    basicAddress
  } = useMemo(() => localizeStation(locale, station), [locale, station])

  const cdn = getGlobalEnv('CDN_BASE_URL')
  const srcSet = getResponsiveSrcSetsFromWH(url, 200, undefined, { webp: true, cdn })

  return <div className={[styles.container, 'flex-grow-0 flex-shrink-0 d-flex flex-column position-relative'].filter(Boolean).join(' ')}>
    <div className={['overflow-hidden', styles.image].filter(Boolean).join(' ')}>
      <Link to={getStationUrl(locale, station, false, false, false)}
            className={[styles.imgWrapper, 'd-flex align-items-center justify-content-center'].join(' ')}>
        <ResponsiveImg  caption={caption}
                        url={url}
                        noLazy={false}
                        srcSet={srcSet}
                        width={thumbnailWidth}
                        height={thumbnailWidth / PHOTO_RATIO}
                        className={styles.photo}/>
      </Link>
    </div>
    <div className={['text-left', styles.info].join(' ')}>
      <Link to={getStationUrl(locale, station, false, false, false)}
            className={['d-block font-weight-bold text-dark ellipsis text-carstay-black', styles.name].join(' ')}>
        {name}
      </Link>
      <div className={['font-weight-bold text-carstay-black', styles.infoText].join(' ')}>
        {activityOnly
          ? <> <h6 className="d-inline-block mb-0 font-weight-bold">¥<FormattedNumber value={activityPrice || 0}/>〜</h6>
            <span className="font-size-12">/<LocaleText ja="1人" en=" per person"/></span>
          </>
          : <> <h6 className="d-inline-block mb-0 font-weight-bold">¥<FormattedNumber value={price || 0}/>〜</h6>
            <span className="font-size-12">/<LocaleText ja="1泊" en=" per night"/></span>
          </>
        }
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <div className={['small ellipsis font-weight-bold', styles.address].join(' ')}>
          <span>{basicAddress || <FormattedMessage id="station.addressNotFound"/>}</span>
        </div>
        <TopStarThumbnail stars={stars} total={totalReviews} className={['d-flex', styles.stars].join(' ')}/>
      </div>
    </div>
  </div>
}
StationItem.displayName = 'StationItem'
export default StationItem
